import React, { Component } from 'react'
import Dropzone from 'react-dropzone'
import Box from '@material-ui/core/Box'
import { getSiteClass } from 'config/helpers/Helpers'

class FileUpload extends Component {
	constructor(props) {
		super(props)
		this.state = {

		}
	}

	onFileSelect(files) {
		console.log(files[0])
		this.setState({
			file: files[0],
		})
		this.submitFile()
	}

	submitFile() {
		console.log('submit file: ', this.state.file)

		this.props.updateFile(this.state.file)

		/*
		Auth.currentUserInfo().then((info) => {
			console.log(info)

			let path = 'catering/weekly-menus/' + Date.now()
			console.log('Date path: ', path)
            
            Storage.put(path, this.state.file, {
	    		contentType: this.state.file.type
	  		}).then((data) => {
	  			console.log(data)
	  			this.props.updateCurrentMenu(path)
	  		});
        }).catch((err) => {
            console.log(err);
    	})
    	*/
	}

	render() {
		//let dropzoneRef: any
		return (
    		<Dropzone
              	multiple={false}
              	//disableClick={this.props.disableClick}
              	accept={'application/pdf, image/*'}
              	onDrop={this.onFileSelect.bind(this)}
            >
            	{({ getRootProps, getInputProps }) => (
			      	<div {...getRootProps()}>
				        <input {...getInputProps()} />
				        
				        {!this.state.file &&
							<Box className='file-upload-box'>
								<Box
									fontSize='1rem'
									color={'#bbb'}
									//marginTop='2rem'
									textAlign='center'
									//style={{textDecorationStyle: 'underline'}}
								>
									<Box>
										<i className='ni ni-cloud-upload-96'></i>
									</Box>
									<Box component='small' fontSize='100%' className='q-tip'>
										Click to select a file
									</Box>
								</Box>
							</Box>
	                  	}
	                  	{this.state.file &&
	                  		<p className={getSiteClass(this.props.companyId)}>{this.state.file.name}</p>
	                  	}
			      	</div>
				)}
           	</Dropzone> 
	    )
	}
}

export default FileUpload